// Flickity Sliders Initialization
// This script initializes Flickity sliders for both single and full sliders.
// It applies custom styling to the navigation buttons and page dots using DaisyUI classes.
import Flickity from 'flickity';

document.addEventListener('DOMContentLoaded', () => {

  const singleSliders = document.querySelectorAll('.carousel-single');
  const fullSliders = document.querySelectorAll('.carousel-multiple');
  
  if (singleSliders.length > 0) {
    singleSliders.forEach(function(slider) {
      new Flickity(slider, {
        // Options
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        pageDots: true,
        prevNextButtons: true,
        adaptiveHeight: false,
        imagesLoaded: true,
      });
    });
  }

  if (fullSliders.length > 0) {
    fullSliders.forEach(function(slider) {
      new Flickity(slider, {
        // Options
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        adaptiveHeight: false,
        imagesLoaded: true,
        groupCells: true,
      });
    });
  }

});